/**
 * Created by sswaminathan on 1/9/22
 * File: TextBox
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Input } from '@panwds/react-form-legacy'
import { Body } from '@panwds/react-ui'
import { toNumber } from 'lodash'
/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useEffect, useMemo, useState } from 'react'

import { useFormContext } from 'react-hook-form'
import {
  APP_ID_LOGGING_SERVICE,
  APP_ID_PRISMA_ACCESS_EDITION, APP_ID_TRAFFIC_MIRRORING
} from '../../../common/constants/GlobalConstants'
import { isNonemptyArray } from '../../../common/utils/Utils'
import { CASB, SUBSCRIPTION_ACTION_EDIT, URL_VALIDATIONS } from '../constants/SubscriptionConstant'
import { Validation } from '../validation/Validation'

const TextBox = (props) => {
  const {
    width, height, licenseValue, defaultCapacity,
    disabled, appId: app_id, checkBoxLabelDesc,
    validationRules, regex, name, allocation,
    item, product, ...rest } = props
  const [capacityValue, setCapacityValue] = useState(defaultCapacity)
  const { setValue, trigger, getValues, watch } = useFormContext()
  const [placeHolder, setPlaceHolder] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const primaryFieldAppIds = item?.products?.filter(({ app_id, license_type }) => {
    return app_id === APP_ID_PRISMA_ACCESS_EDITION && license_type?.includes('-MU')
  }).map(_each => _each.formFieldName)
  const watchBaseProducts = app_id === APP_ID_TRAFFIC_MIRRORING ? watch(primaryFieldAppIds) : null
  const STYLE = {
    'justifyContent': 'space-between',
    color: '#1D2124',
    'borderRadius': '3px',
    width: width ? width : '172px',
    height: height ? height : '32px',
    background: '#FFFFFF',
    textTransform: 'lowercase'
  }
  /**
   * Update the CASB validation based on the app_id
   * @type {unknown}
   * @private
   */
  const baseTotal = useMemo(() => {
    return watchBaseProducts?.reduce((result, _each) => {
      result = result + +_each
      return result
    }, 0)
  }, [watchBaseProducts])

  const _validationRules = useCallback(() => {
    if (app_id === CASB) {
      const prisma_access_edition = item?.products?.find(({ app_id }) => app_id === APP_ID_PRISMA_ACCESS_EDITION)
      validationRules.app_id = CASB
      return { ...validationRules, app_id: CASB, min_quantity: getValues(prisma_access_edition?.formFieldName) ?? 0 }
    }
    if (app_id === APP_ID_TRAFFIC_MIRRORING) {
      validationRules.min_quantity = baseTotal
    }
    return { ...validationRules }
  }, [app_id, baseTotal, getValues, item?.products, validationRules])


  /**
   * Trigger validation on load of the screen
   */
  useEffect(() => {
    !URL_VALIDATIONS.includes(app_id) && trigger(name)
  }, [app_id, defaultCapacity, name, trigger])

  /**
   * Update the capacity value and placeholder
   */
  useMemo(() => {
    setPlaceHolder(() => {
      return URL_VALIDATIONS.includes(app_id) ? '//URL Subnet' : ''
    })
    setCapacityValue(prev => {
      return URL_VALIDATIONS.includes(app_id) ? '' : defaultCapacity ? defaultCapacity : prev
    })
  }, [setCapacityValue, defaultCapacity, app_id])
  /**
   *  This function calculates the max an min values during the edit operation
   * @type {unknown}
   */
  const editRules = useMemo(() => {
    if (rest.licenseAction === SUBSCRIPTION_ACTION_EDIT) {
      const paeEntitlements = rest?.licenseInfo[APP_ID_PRISMA_ACCESS_EDITION]?.entitlements
      const isAppPresentInEntitlement = isNonemptyArray(paeEntitlements) &&
        paeEntitlements.find(({ app_id: _app_id, license_type }) => _app_id.concat('-', license_type) === app_id.concat('-', product.license_type))
      let allocatedSize
      let max_quantity = 0
      switch (app_id) {
        case APP_ID_LOGGING_SERVICE: {
          allocatedSize = rest.licenseInfo[app_id]?.extra?.purchased_size ?? 0
          max_quantity = toNumber(validationRules?.max_quantity ?? 0) + allocatedSize
          break
        }
        default: {
          allocatedSize = isAppPresentInEntitlement?.purchased_size ?
            toNumber(isAppPresentInEntitlement?.purchased_size) : toNumber(validationRules?.min_quantity ?? 0)
          max_quantity = toNumber(validationRules?.max_quantity ?? 0) + (isAppPresentInEntitlement?.purchased_size ?? 0)
        }
      }
      if ((isAppPresentInEntitlement || rest.licenseInfo[app_id])) {
        return {
          app_id: app_id,
          min_quantity: allocatedSize,
          max_quantity: max_quantity
        }
      }
    }
    return {}

  }, [app_id, product.license_type, rest.licenseAction, rest.licenseInfo, validationRules?.max_quantity, validationRules?.min_quantity])

  useEffect(() => {
    if (app_id !== APP_ID_TRAFFIC_MIRRORING) {
      setCapacityValue(defaultCapacity)
      setValue(name, defaultCapacity)
    }
    else {
      setCapacityValue(baseTotal)
      setValue(name, baseTotal)
    }
    rest.licenseAction !== SUBSCRIPTION_ACTION_EDIT && !URL_VALIDATIONS.includes(app_id) && trigger(name)
  }, [allocation, defaultCapacity, setValue, name, trigger, rest.licenseAction, app_id, item.products, baseTotal])



  return <div><Input
    addClassName='tw-h-12'
    style={STYLE}
    register={{
      required: false,
      onChange: ((e) => {
        setCapacityValue(e.target.value)
        if (!URL_VALIDATIONS.includes(app_id)) {
          trigger(name)
        }
      }),
      validate: Validation({ validationRules: _validationRules(), appId: app_id, editRules, setErrorMessage, ...rest })
    }}
    value={capacityValue}
    name={name}
    label={checkBoxLabelDesc}
    showLabel={false}
    disabled={disabled}
    placeholder={placeHolder}/>{(allocation && disabled) ? <Body className="tw-text-red" style={{ fontsize: '12px' }} size='xs'>{errorMessage}</Body> : <></>}
  </div>
}

TextBox.propTypes = {}
export default TextBox
